(function () {
	'use strict';

	// ─── Sticky header ──────────────────────────────────────────────────────────
	// The header is sticky with top = -(banner height), so the launch banner
	// scrolls away and the header bar stays pinned (see _header.scss). The banner
	// is the first child of the header's root flexbox; its height changes when the
	// text wraps, so it is measured rather than hard-coded.

	function init() {
		var header = document.querySelector('.elementor-location-header');
		if (!header) {
			return;
		}

		var banner = header.querySelector(':scope > .e-con > .e-con:first-child');

		function measure() {
			var height = banner ? banner.offsetHeight : 0;
			header.style.setProperty('--arelis-banner-h', height + 'px');
		}

		measure();
		if (banner && 'ResizeObserver' in window) {
			new ResizeObserver(measure).observe(banner);
		}

		// Figma: shadow once the page has scrolled more than 8 px, removed on the way back
		var scrolled = false;
		function onScroll() {
			var next = window.scrollY > 8;
			if (next !== scrolled) {
				scrolled = next;
				header.classList.toggle('is-scrolled', scrolled);
			}
		}

		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

})();
